import { render, staticRenderFns } from "./model_tip.vue?vue&type=template&id=e017483e&scoped=true"
import script from "./model_tip.vue?vue&type=script&lang=js"
export * from "./model_tip.vue?vue&type=script&lang=js"
import style0 from "./model_tip.vue?vue&type=style&index=0&id=e017483e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e017483e",
  null
  
)

export default component.exports